export default __webpack_public_path__ + "static/media/1.8c6304d2.jpg";